import { CheckEmailCodeForm } from 'Components/forms/applyJobForms/ApplyJobCheckEmailForm';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Dialog, Flex, Box, IconButton, Text, Heading, } from '@radix-ui/themes';
import { CloseIcon } from 'shared/icons';
import { useApplyJobCtx } from '../apply-job-provider';
import { GoogleAnalyticsService } from 'core/services/GoogleAnalyticsService';
import { FormEvent } from 'react';
import { useRootStore } from 'core/hooks/use-root-store';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';

function ConfirmCodeView({ checkUserMessage, ...props }: any) {
   const rootStore = useRootStore();
   const applyJobStore = useApplyJobCtx();

   const confirmCodeStore = applyJobStore.confirmCodeStore;
   const { t } = useTranslation('global');
   return (
      <>
         <Flex mb="4" width="100%" justify="between">
            <Box>
               <Heading as="h2" weight="medium">
                  {props.phoneConfirmed ? 'Підтвердіть телефон' : t('jobDescription.emailConfirm')}:
               </Heading>

               <Box mt="7" mb="3">
                  <Text color="gray" highContrast size="3">
                     {checkUserMessage}
                  </Text>
               </Box>
            </Box>

            <Dialog.Close>
               <IconButton size="1" color="blue" highContrast variant="soft" radius="full">
                  <CloseIcon />
               </IconButton>
            </Dialog.Close>
         </Flex>
         <CheckEmailCodeForm
            {...props}
            emailConfirmCode={confirmCodeStore.codeControl.value}
            emailConfirmCodeError={confirmCodeStore.codeControl.error}
            isSubmitting={confirmCodeStore.processing}
            setEmailConfirmCode={(code: string) => {
               confirmCodeStore.codeControl.setValue(code);
            }}
            onSubmit={(e: FormEvent) => {
               e.preventDefault();

               GoogleAnalyticsService.trackEvent('jobseeker_code_confirm', {
                  INFO: 'code start',
               });

               confirmCodeStore.codeControl.validate();
               if (confirmCodeStore.codeControl.valid) {
                  confirmCodeStore.confirmEmailOrPhone({
                     onSuccess: (res) => {
                        rootStore.userStore.setUser(res.response.user);

                        const {
                           token,
                           contact,
                           user_id,
                           last_name,
                           user_type,
                           first_name,
                           email_address,
                        } = res.response.user;
                        

                        const Toast = Swal.mixin({
                           toast: true,
                           timer: 5000,
                           position: 'top-end',
                           timerProgressBar: true,
                           showConfirmButton: false,
                           didOpen: (toast) => {
                              toast.addEventListener('mouseenter', Swal.stopTimer);
                              toast.addEventListener('mouseleave', Swal.resumeTimer);
                           },
                        });

                        Cookies.set('lname', last_name);
                        Cookies.set('user_id', user_id.toString());
                        Cookies.set('fname', first_name);
                        Cookies.set('tokenClient', token);
                        Cookies.set('user_type', user_type);
                        Cookies.set('contactNumber', contact ?? '');
                        Cookies.set('emailAddress', email_address);

                        Toast.fire({
                           icon: 'success',
                           title: t('jobseekerLogin.welcome') + ', ' + first_name,
                        });

                        GoogleAnalyticsService.trackEvent('jobseeker_registration', {
                           SUCCESS: t('jobseekerLogin.welcome') + ', ' + first_name,
                        });

                        props.setStep?.('jobApplySelect');
                     },
                  });
               } else {
                  GoogleAnalyticsService.trackEvent('jobseeker_code_confirm', {
                     WARNING: 'Validation failed',
                  });
               }
            }}
         />
      </>
   );
}

export const ConfirmCode = observer(ConfirmCodeView);
